import Footer from '@/components/Footer/footer';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useCallback, useEffect, useMemo } from 'react';
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { GoToAppOrStoreImage } from '../GoToAppOrStoreImage';
import { GoToAppOrStoreProps } from '../index';
import './styles.scss';

const GoToAppOrStoreWhiteLabel: React.FC<GoToAppOrStoreProps> = ({ autoRedirect, customBtnConfig }: GoToAppOrStoreProps) => {
    const {
        strings,
        appOrganization: {
            colors: [primaryColor],
            organization,
            application,
            isTotvs,
            dynamicAttributes: { playStoreUrl, appleStoreUrl },
        },
    } = useSelector((state: ApplicationState) => ({
        appOrganization: state.appOrganization.data,
        strings: state.locale.data,
    }));

    const orgLogo = useMemo(
        () => `${Constants.ORG_LOGO.replace('%s', organization.orgKey).replace('%s', application.key.toLowerCase())}?force=${Date.now()}`,
        [organization, application],
    );

    const redirectToStore = useCallback(() => {
        if (isTotvs) {
            window.location.href = isIOS ? Constants.mobileApp.IOS_APP_STORE_TOTVS : Constants.mobileApp.ANDROID_PLAY_STORE_TOTVS;
            return;
        }
        if (!appleStoreUrl || !playStoreUrl) {
            return;
        }
        window.location.href = isIOS ? appleStoreUrl : playStoreUrl;
    }, [isTotvs, playStoreUrl, appleStoreUrl]);

    const handleClick = useCallback(() => {
        if (customBtnConfig?.action) {
            return customBtnConfig.action();
        }
        return redirectToStore();
    }, [redirectToStore]);

    useEffect(() => {
        if (autoRedirect) {
            if (isMobileOnly && (isAndroid || isIOS)) {
                isAndroid && setTimeout(() => redirectToStore(), 2000);
                if (isTotvs) {
                    window.location.href = Constants.mobileApp.APP_HOME_DEEP_LINK_TOTVS;
                    return;
                }
                window.location.href = Constants.mobileApp.APP_HOME_DEEP_LINK;
            }
        }
    }, [autoRedirect, redirectToStore]);

    return (
        <div className="goto-app-or-store-whitelabel-container">
            <img alt={`${strings.LOGO_OF_COMPANY} ${organization.name}`} className="org-logo-img" src={orgLogo} />

            <div className="image-decoration-container">
                <GoToAppOrStoreImage color={primaryColor} />
            </div>

            <div className="information-text-container">
                <h4>{strings.GO_TO_APP_OR_STORE_TITLE}</h4>
                <span>{strings.GO_TO_APP_OR_STORE_DESCRIPTION}</span>
            </div>

            <button className="btn btn-primary btn-block store-button" onClick={handleClick} type="button">
                {customBtnConfig?.label || strings.CLICK_TO_DOWLOAD_APP}
            </button>

            <Footer />
        </div>
    );
};

export { GoToAppOrStoreWhiteLabel };
